
var ExternalScreen = {
  checkAvailability: function (success, fail) {
    cordova.exec(success, fail, "ExternalScreen", 'checkAvailability', []);
  },
  loadHTML: function (baseUrl, html, success, fail) {
    cordova.exec(success, fail, "ExternalScreen", 'loadHTML', [baseUrl, html]);
  },
  invokeJavaScript: function (str, success, fail) {
    cordova.exec(success, fail, "ExternalScreen", 'invokeJavaScript', [str]);
  },
  checkOut: function(success, fail) {
    cordova.exec(success, fail, "ExternalScreen", 'checkOut', []);
  },
  getCurrentTime: function(success, fail) {
    cordova.exec(success, fail, "ExternalScreen", 'getCurrentTime', []);
  },
  getScreenWidth: function(success, fail) {
    cordova.exec(success, fail, "ExternalScreen", 'getScreenWidth', []);
  }
};

module.exports = ExternalScreen;
